<template>
	<router-link
		v-if="!isExternal"
		:to="linkUrl"
		:class="classname"
		:target="target"
		:title="title"
		:aria-label="title"
		:rel="target === '_blank' ? 'noopener' : ''"
		ref="link"
		:exact="exact"
	>
		<slot></slot>
	</router-link>

	<a
		v-else
		:href="linkUrl"
		:class="classname"
		:target="target"
		:aria-label="title"
		:rel="target === '_blank' ? 'noopener' : ''"
		:title="title"
		ref="link"
	>
		<slot></slot>
	</a>
</template>

<script>
import { isExternal } from '@/helpers'

export default {
	name: 'wp-link',
	props: ['url', 'title', 'classname', 'target', 'type', 'id'],
	mounted: function () {},
	data() {
		return {
			homeUrl: window.WPVUE.home,
		}
	},
	watch: {},
	computed: {
		exact() {
			if (this.linkUrl === '/') return true
			return false
		},

		linkUrl() {
			let url = this.url.replace(/\/$/, '')
			const homeUrl = this.homeUrl.replace(/\/$/, '')
			//remove home url if link contain it

			if (url && url !== '' && url.includes(homeUrl)) {
				url = url.replace(homeUrl, '')
			}
			//console.log('b', url)
			//console.log(homeUrl)
			//console.log(url)
			return url
		},
		isExternal() {
			const url = this.linkUrl
			const homeUrl = this.homeUrl.replace(/\/$/, '')

			return isExternal(url, homeUrl)
		},
	},
	methods: {},
}
</script>
